<template>
    <div class="custom-msg">
        <!-- Custom Message Settings - message content -->
        <el-form-item
            class="el-checkbox"
            :label="$t.__('pages.account.sale.CustomMessage.custom_message')"
        >
            <el-checkbox v-model="messageUsed" class="mt-2 flex-row" :label="messageUsed">
                {{ $l10n.__('Joindre mon message personnalisé dans l’email envoyé') }}
            </el-checkbox>
        </el-form-item>
        <div v-show="messageUsed">
            <el-form-item prop="customMessage">
                <RichText
                    v-model="message"
                    :placeholder="$t.__('common.actions.enter_custom_message')"
                    :options="optionsRichText"
                    class="custom-richtext"
                />
            </el-form-item>
            <p class="fs-2 gray-60 mt-3">
                {{
                    $l10n.__(
                        'Votre nom et email seront automatiquement ajoutés après votre message personnalisé.',
                    )
                }}
            </p>
        </div>
    </div>
</template>
<script>
import RichText from 'vcomponents/richtext/RichText.vue';

export default {
    components: {
        RichText,
    },
    props: {
        context: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            optionsRichText: [
                'Bold',
                'Italic',
                'Underline',
                'BulletList',
                'OrderedList',
                'Divider',
                'Link',
            ],
        };
    },
    computed: {
        messageUsed: {
            get() {
                return this.$store.getters[`${this.context}Cart/isCustomMessageUsed`];
            },
            set(value) {
                this.$store.commit(`${this.context}Cart/setCustomMessageUsed`, value);
            },
        },
        message: {
            get() {
                return this.$store.getters[`${this.context}Cart/customMessage`];
            },
            set(value) {
                this.$store.commit(`${this.context}Cart/setCustomMessage`, value);
            },
        },
    },
};
</script>
<style lang="scss" scoped>
.el-checkbox {
    &::v-deep {
        .el-checkbox__input {
            padding-top: 2px;
        }
    }
}
</style>
